import classNames from "classnames";
import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { toast, ToastContainer } from "react-toastify";
import { Breadcrumb, BreadcrumbItem, Button, Card, CardBody, CardFooter, CardHeader, Col, Input, InputGroup, InputGroupAddon, InputGroupText, Modal, ModalBody, ModalFooter, ModalHeader, Pagination, Row, Spinner, Table } from "reactstrap";
import SparePartService from "../../services/SparePartService";

class SparePartGroups extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            groupsData: {
                request: {
                    pageRequest: {
                        currentPage: 1,
                        pageSize: 50,
                    },
                    sortRequest: {
                        key: "",
                        direction: false
                    },
                    filterRequest: {
                        name: ""
                    }
                },
                response: {
                    records: [],
                    totalRecords: 0,
                    currentPage: 1,
                    pageSize: 50
                }
            },
            showDeleteModal: false,
            deleteGroupId: null,
        };

        this.SparePartService = new SparePartService();
    }

    componentDidMount() {
        this.getGroups(this.state.groupsData);
    }

    getGroups = (groupsData) => {
        this.setState({ loading: true });

        this.SparePartService.listGroups(groupsData.request)
            .then(res => {
                groupsData.response = res.data;
                this.setState({ groupsData, loading: false });
            })
            .catch(() => this.setState({ loading: false }));
    };

    getGroupHeaders({ filterRequest }) {
        return [
            {
                key: "srNo",
                label: "Sr. No",
                sorterApplicable: false,
                minWidth: 60,
                searchNode: null,
            },
            {
                key: "name",
                label: "Name",
                sorterApplicable: true,
                minWidth: 120,
                searchNode: (
                    <Input
                        type="search"
                        value={filterRequest.name}
                        onChange={(e) => this.handleChange(e.target.value, "name")}
                        placeholder="Search..."
                    />
                ),
            },
            {
                key: "shortName",
                label: "Short Name",
                sorterApplicable: false,
                minWidth: 100,
                searchNode: null,
            },
            {
                key: "code",
                label: "Code",
                sorterApplicable: false,
                minWidth: 100,
                searchNode: null,
            },
            {
                key: "sortOrder",
                label: "Sort Order",
                sorterApplicable: false,
                minWidth: 100,
                searchNode: null,
            },
            {
                key: "action",
                label: "Action",
                type: "action",
                colSpan: 1,
                minWidth: 100,
                sorterApplicable: false,
                valueClassName: "text-center",
                labelClassName: "align-middle text-center",
                searchNodeColSpan: 1,
                searchNode: <div className="text-center"><Link className="btn btn-primary btn-sm"
                    to={{ pathname: "/sparepart/groups/details", state: {} }}><i
                        className="fa fa-plus" />&nbsp;
                    Add </Link></div>
            }
        ];
    }

    handleChange = (change, key) => {
        let { groupsData } = this.state;

        switch (key) {
            case "sortKey":
                if (groupsData.request.sortRequest.key === change) {
                    groupsData.request.sortRequest.direction = !groupsData.request.sortRequest.direction;
                } else {
                    groupsData.request.sortRequest.key = change;
                    groupsData.request.sortRequest.direction = false;
                }
                this.getGroups(groupsData);
                break;
            case "pageSize":
                groupsData.request.pageRequest.pageSize = parseInt(change);
                groupsData.request.pageRequest.currentPage = 1;
                this.getGroups(groupsData);
                break;
            case "currentPage":
                groupsData.request.pageRequest.currentPage = change;
                this.getGroups(groupsData);
                break;
            default:
                groupsData.request.filterRequest[key] = change;
                groupsData.request.pageRequest.currentPage = 1;
                this.getGroups(groupsData);
        }
        this.setState({ groupsData });
    };

    handleDelete = () => {
        const { deleteGroupId } = this.state;
        this.SparePartService.deleteGroup(deleteGroupId)
            .then(() => {
                toast.success("Deleted");
                this.getGroups(this.state.groupsData);
                this.cancelDelete();
            })
            .catch((err) => {
                const message =
                    err.response?.data?.Message || "Failed to delete the sub group.";
                toast.error(message);
            }).finally(() => {
            });
    };

    confirmDelete = (id) => {
        this.setState({ showDeleteModal: true, deleteGroupId: id });
    };

    cancelDelete = () => {
        this.setState({ showDeleteModal: false, deleteGroupId: null });
    };

    render() {
        const { loading, groupsData } = this.state;
        const { pageRequest, sortRequest, filterRequest } = groupsData.request;
        let groupsHeading = this.getGroupHeaders({ filterRequest });

        return (
            <div>
                <Breadcrumb tag="nav" listTag="div">
                    <BreadcrumbItem tag="a" href="javascript:void(0)"
                        onClick={() => this.props.history.push('/')}>Home</BreadcrumbItem>
                    <BreadcrumbItem active tag="span">Spare Parts Groups</BreadcrumbItem>
                </Breadcrumb>
                <Card>
                    <CardHeader>
                        <h5 className="mb-0">Spare Part Groups</h5>
                    </CardHeader>

                    <CardBody>
                        <Row>
                            <Col>
                                {loading ? (
                                    <Spinner size="sm" color="primary" />
                                ) : (
                                    <span>
                                        Showing {(pageRequest.currentPage - 1) * pageRequest.pageSize + 1}{" "}
                                        to {Math.min(pageRequest.currentPage * pageRequest.pageSize, groupsData.response.totalRecords)}{" "}
                                        of {groupsData.response.totalRecords} entries
                                    </span>
                                )}
                            </Col>
                        </Row>

                        <Table striped bordered hover responsive size="sm" className="mt-3">
                            <thead>
                                <tr>
                                    {(groupsHeading || []).map((item, index) => {
                                        return (
                                            <th key={index}
                                                onClick={() => this.handleChange(item.key, "sortKey")}
                                                colSpan={item.colSpan}
                                                className={item.labelClassName}
                                                style={{ minWidth: item.minWidth }}>
                                                {item.label}
                                                {
                                                    item.sorterApplicable ?
                                                        <i className={classNames("fa", "float-right", "pt-1", {
                                                            "fa-sort": (sortRequest.key !== item.key),
                                                            "fa-sort-amount-asc": (sortRequest.key === item.key && sortRequest.direction),
                                                            "fa-sort-amount-desc": (sortRequest.key === item.key && !sortRequest.direction),
                                                        }
                                                        )} aria-hidden="true" /> : null
                                                }

                                            </th>
                                        );
                                    })}
                                </tr>
                                <tr>
                                    {groupsHeading.map((item, index) => (
                                        <td
                                            key={index}
                                            colSpan={item.searchNodeColSpan || 1}
                                            className="align-middle text-center"
                                        >
                                            {item.searchNode || null}
                                        </td>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {(groupsData.response.records || []).map((g, index) => (
                                    <tr key={g.id}>
                                        <td>
                                            {(pageRequest.currentPage - 1) * pageRequest.pageSize + (index + 1)}
                                        </td>
                                        <td>{g.name}</td>
                                        <td>{g.shortName}</td>
                                        <td>{g.code}</td>
                                        <td>{g.sortOrder}</td>
                                        <td className="text-center"><Link
                                            className="btn btn-sm btn-primary"
                                            to={{
                                                pathname: "/sparepart/groups/details",
                                                state: { group: g }
                                            }}> <i className="fa fa-pencil mr-2"
                                                aria-hidden="true" />Edit</Link><span>&nbsp;&nbsp;</span>
                                            <Button
                                                color="danger"
                                                size="sm"
                                                onClick={() => this.confirmDelete(g.id)}
                                            >
                                                <i className="fa fa-trash" />
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </CardBody>

                    <CardFooter>
                        <Row>
                            <Col md={4}>
                                <InputGroup style={{ maxWidth: 200 }}>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>Show</InputGroupText>
                                    </InputGroupAddon>
                                    <Input
                                        type="select"
                                        value={pageRequest.pageSize}
                                        onChange={(e) => this.handleChange(e.target.value, "pageSize")}
                                        disabled={loading}
                                    >
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </Input>
                                </InputGroup>
                            </Col>

                            <Col md={8}>
                                <div className="float-right">
                                    <Pagination
                                        activePage={pageRequest.currentPage}
                                        itemsCountPerPage={pageRequest.pageSize}
                                        totalItemsCount={groupsData.response.totalRecords}
                                        pageRangeDisplayed={3}
                                        onChange={(p) => this.handleChange(p, "currentPage")}
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        innerClass="pagination"
                                    />
                                </div>
                            </Col>
                        </Row>
                    </CardFooter>
                </Card>

                <ToastContainer />
                <Modal isOpen={this.state.showDeleteModal} toggle={this.cancelDelete}>
                    <ModalHeader toggle={this.cancelDelete}>Confirm Delete</ModalHeader>
                    <ModalBody>Are you sure you want to delete this group?</ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={this.handleDelete}>Delete</Button>
                        <Button color="secondary" onClick={this.cancelDelete}>Cancel</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default SparePartGroups;
